export default __webpack_public_path__ + "static/prof-app-46aeb2d737ef7cb286ca173c45e58122.png";